module.exports = __webpack_public_path__ + "img/calendr-chevron-left.7f1183ca.svg";